import { gql } from "@apollo/client";

export default gql`
  query users{
    users{
        success
        data{
            _id
            name
            surname
            role
            phone
            email
            createdAt
        }
        code
        message
    }
}
`
